import { ProviderDomain } from "../reducers/providerReducer";

export type Action = { type: "SET_PROVIDER"; payload: ProviderDomain };

export const setProvider = (type: ProviderDomain): Action => ({
  type: "SET_PROVIDER",
  payload: type,
});
